<template>
  <div>
    <Dropdown ref="dropdown">
      <template #button="{ open }">
        <BaseButton small ghost @click="open" class="flex">
          {{ $t('contact.actions') }}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4 ml-3"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <circle cx="12" cy="12" r="1" />
            <circle cx="12" cy="19" r="1" />
            <circle cx="12" cy="5" r="1" />
          </svg>
        </BaseButton>
      </template>

      <div
        class="origin-top-right absolute right-0 mt-2 max-w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="options-menu"
      >
        <div class="py-1">
          <button
            v-if="contact.unsubscribeRequestId === null"
            type="button"
            class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
            role="menuitem"
            @click="showUnsubscribeDialog"
          >
            {{ $t('contact.unsubscribe') }}
          </button>
        </div>
        <div class="py-1">
          <button
            type="button"
            class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
            role="menuitem"
            @click="showDeleteContactModal"
          >
            {{ $t('contact.delete') }}
          </button>
        </div>
      </div>
    </Dropdown>
  </div>
</template>

<script>
export default {
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  inject: ['closeModal', 'deleteContact'],
  methods: {
    async showDeleteContactModal() {
      this.$modal.show({
        component: () => import('Components/Contacts/ContactDeleteModal.vue'),
        props: {
          action: async () => {
            try {
              await this.deleteContact();

              return Promise.resolve();
            } catch (error) {
              return Promise.reject(error);
            }
          },
          contact: this.contact,
        },
        on: {
          'contact-deleted': (contact) => {
            this.$emit('contact-deleted', contact);
          },
        },
        hideEvent: 'hide',
      });
    },
    showUnsubscribeDialog() {
      this.$modal.show({
        component: () => import('Components/Contacts/UnsubscribeDialog.vue'),
        props: {
          contact: this.contact,
        },
        on: {
          'contact:unsubscribed': () => {
            this.$router.replace({
              name: this.$route.name,
              params: {
                ...this.$route.params,
              },
              query: {
                ...this.$route.query,
                updated: new Date().getTime(),
              },
            });
            this.closeModal();
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
